import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import {
  GetAnniversariesResponse,
  GetBirthdaysResponse,
  GetProfilesParams,
  getAnniversaries,
  getBirthdays,
} from "./profileApi";

export function useBirthdaysQuery(
  params?: GetProfilesParams,
  options?: UseQueryOptions<GetBirthdaysResponse>,
) {
  return useQuery<GetBirthdaysResponse>({
    ...options,
    queryKey: ["birthdays", params?.from, params?.to],
    queryFn: () => getBirthdays(params),
  });
}

export function useAnniversariesQuery(
  params?: GetProfilesParams,
  options?: UseQueryOptions<GetAnniversariesResponse>,
) {
  return useQuery<GetAnniversariesResponse>({
    ...options,
    queryKey: ["anniversaries", params?.from, params?.to],
    queryFn: () => getAnniversaries(params),
  });
}
